export const StreetIcon = (props) => (
	<svg
		fill="none"
		height={18}
		viewBox="0 0 18 18"
		width={18}
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M14.25 15.75V3.75C14.25 3.35218 14.092 2.97064 13.8107 2.68934C13.5294 2.40804 13.1478 2.25 12.75 2.25H5.25C4.85218 2.25 4.47064 2.40804 4.18934 2.68934C3.90804 2.97064 3.75 3.35218 3.75 3.75V15.75M14.25 15.75H15.75M14.25 15.75H10.5M3.75 15.75H2.25M3.75 15.75H7.5M10.5 15.75V12C10.5 11.8011 10.421 11.6103 10.2803 11.4697C10.1397 11.329 9.94891 11.25 9.75 11.25H8.25C8.05109 11.25 7.86032 11.329 7.71967 11.4697C7.57902 11.6103 7.5 11.8011 7.5 12V15.75M10.5 15.75H7.5M6.75 5.25H7.5M6.75 8.25H7.5M10.5 5.25H11.25M10.5 8.25H11.25"
			stroke="#A0A5AF"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
